import decodeAuthenticationToken from './decodeAuthenticationToken';

export default function makeAuthenticationCookieOptions(token) {
  const decodedToken = decodeAuthenticationToken(token);

  if (decodedToken === null) {
    throw Error("Failed to decode authentication token.");
  }

  const baseOptions = {
    expires: new Date(decodedToken.exp * 1000),
  };

  return process.env.NODE_ENV === 'production'
    ? { ...baseOptions, secure: true, sameSite: 'strict' }
    : baseOptions;
}
